import { gql } from "@apollo/client";

export const DRIVER = gql`
  query queryDriver($id: Float!) {
    driver(id: $id) {
      id
      balance
      latitude
      longitude
      last_update
      is_online
      state
      phone
      is_deleted
      created_at
      updated_at
      acting_region_id
      name
      image_path
      birth_date
      cpf
      email
      service_provider
      cnh_number
      cnh_image_path
      cnh_expires
      region {
        name
      }
      services {
        service {
          name
          base_rate
          minimum_price
          cost_per_minute
          cost_per_km
          booking_fee
          rush_hour
          is_actived
        }
      }
      categorys {
        category {
          id
          name
        }
      }
      vehicles {
        id
        brand
        model
        board
        color
        year
        image_path
        licensing_path
        state
        categorys {
          category {
            id
            name
          }
        }
        is_deleted
      }
    }
  }
`;

export const DRIVERS = gql`
  query queryDrivers($filter: FilterDriveInput, $franchise_id: Float) {
    drivers(filter: $filter) {
      id
      last_update
      is_online
      state
      name
      phone
      cpf
      balance
      latitude
      longitude
      active_booking
      service_provider
      region {
        name
      }
    }
    franchises {
      id
      name
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export default DRIVER;
